module.exports = __webpack_public_path__ + "static/435bb170009113.5b95745d84b95-e52e8813e6884c50b341ec1822ae8fa5.png";